<h2 mat-dialog-title>{{ ctx.title | translate }}</h2>
<mat-dialog-content>
  <p>{{ctx.text | translate }}</p>
  <div class="flex flex-col p-2">
    <ul>
      @for (item of ctx.items; track item) {
        <li>
          <span>- {{ item | translate }}</span>
        </li>
      }
    </ul>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-between">
  @if (ctx.cancel !== false) {
    <button mat-flat-button mat-dialog-close class="flex-grow bg-tw-disabled">{{ 'CANCEL' | translate }}</button>
  }
  <button mat-flat-button [mat-dialog-close]="true" class="flex-grow bg-tw-primary text-tw-text-light">{{ ctx.valid | translate}}</button>
</mat-dialog-actions>